import { createSlice } from "@reduxjs/toolkit";
import {
  fetchWarehousePacking,
  fetchWarehousePackingIssuePacking,
  fetchCreatePackingPreview,
  FetchPackingById,
} from "./thunk";

interface PRState {
  list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  issuePacking: any;
}

const initialState: PRState = {
  list: [],
  rowCount: 0,
  loading: false,
  error: null,
  issuePacking: null,
};

const WarehouseIssuePackingSlice = createSlice({
  name: "WarehouseIssuePacking",
  initialState,
  reducers: {
    resetIssuePackingState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchWarehousePacking.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWarehousePacking.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchWarehousePacking.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "Failed to fetch Warehouse Packing List";
      })
      .addCase(fetchWarehousePackingIssuePacking.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWarehousePackingIssuePacking.fulfilled, (state, action) => {
        state.loading = false;
        state.issuePacking = action.payload;
      })
      .addCase(fetchWarehousePackingIssuePacking.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message ||
          "Failed to fetch Warehouse Packing Issue Packing";
      })
      .addCase(fetchCreatePackingPreview.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCreatePackingPreview.fulfilled, (state, action) => {
        state.loading = false;
        state.issuePacking = action.payload.data;
        console.log("action.payload", action.payload);
      })
      .addCase(fetchCreatePackingPreview.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message ||
          "Failed to fetch Warehouse Packing Issue Packing";
      })
      .addCase(FetchPackingById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(FetchPackingById.fulfilled, (state, action) => {
        state.loading = false;
        state.issuePacking = action.payload;
      })
      .addCase(FetchPackingById.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message ||
          "Failed to fetch Warehouse Packing Issue Packing";
      });
  },
});

export const { resetIssuePackingState } = WarehouseIssuePackingSlice.actions;
export default WarehouseIssuePackingSlice.reducer;
